<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">計上単位検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_UNIT_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>

      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :disabled="form.id"
                :rules="codeRules"
                clearable
                label="表示CD"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="nameRules"
                clearable
                label="計上単位名称"
                v-model="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      codeRules: [(v) => !!v || "表示CD is required"],
      nameRules: [(v) => !!v || "計上単位名称 is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/record-units", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
